module.exports = __webpack_public_path__ + "img/logo.65692893.png";